import BasicPageLayout from 'layouts/BasicPage';
import useHttpQuery from 'data/firestore/useHttpQuery';
import { useParams } from 'react-router-dom';
import { Container, Content } from './styled';
import Sidebar from './Sidebar';
import ContentArea from './ContentArea';
import useQueryFilters from './hooks/useQueryFilters';
import { Memory } from './types';

const MemoryManagement = () => {
    const { agentId } = useParams();
    const filters = useQueryFilters();
    const { data = {}, isLoading } = useHttpQuery<any>({
        key: ['memories', agentId, ...Object.values(filters)],
        method: 'POST',
        pathname: `/agents/${agentId}/customers/${filters.customerId}/memories/search`,
        body: {
            types: filters.types,
            minImportance: filters.minImportance,
            maxImportance: filters.maxImportance,
            relativeTime: filters.relativeTime,
            segmentPrefix: filters.segmentPrefix,
            query: filters.query,
            limit: filters.limit,
        },
        queryOptions: {
            enabled: Boolean(filters.customerId),
        },
    });

    const {
        data: memories, hits, total: totalMemories,
    } = data;

    return (
        <BasicPageLayout>
            <Container>
                <Content>
                    <Sidebar
                        filters={filters}
                    />
                    <ContentArea
                        selectedCustomer={filters.customerId}
                        memories={memories as Memory[]}
                        totalMemories={totalMemories}
                        filteredMemories={hits}
                        isLoading={isLoading}
                    />
                </Content>
            </Container>
        </BasicPageLayout>
    );
};

export default MemoryManagement;
